<template>
    <div class="container" ref="containerRef">
        <!-- 搜索条件 -->
        <div class="search-box" ref="searchBoxRef">
            <div class="search-item">
                <el-input v-model="searchForm.name" placeholder="商品名称/批准文号/医药公司/产品线名称/代理/团队" size="small"></el-input>
            </div>
            <div class="search-btn">
                <el-button type="primary" size="small" @click="handleSearch">搜索</el-button>
                <el-button  size="small" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- 表格 -->
        <div class="search-form">
            <el-table :data="tableData" border style="width: 100%" ref="tableBoxRef" :height="tableBoxHeight">
                <!-- 商品信息 -->
                <el-table-column label="商品信息" min-width="250">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;">
                            <!-- 商品图片 -->
                            <img :src="scope.row.image" style="width: 88px;height: 88px;">
                            <!-- 商品信息 -->
                            <div style="margin-left: 10px;">
                                <div>{{ scope.row.goodsName }}</div>
                                <div>{{ scope.row.factory }}</div>
                                <div>{{ scope.row.specification }}</div>
                                <div>{{ scope.row.approvalNumber }}</div>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- 库存 -->
                <el-table-column label="库存" prop="orderStatus" min-width="250">
                    <template slot-scope="scope">
                        <div>总库存：{{ scope.row.goodsSkuInventory }}</div>
                        <div>有效期至：{{ scope.row.expireTime }}</div>
                        <div>生产日期：{{ scope.row.producedTime }}</div>
                    </template>
                </el-table-column>
                <!-- 医药公司 -->
                <el-table-column label="医药公司" prop="shopName" min-width="250"></el-table-column>
                <!-- 代理 -->
                <el-table-column label="代理" prop="bagShopName" min-width="150"></el-table-column>
                <!-- 团队 -->
                <el-table-column label="团队" prop="teamShopName" min-width="250"></el-table-column>
                <!-- 产品线名称 -->
                <el-table-column label="产品线名称" prop="productLineName" min-width="250">
                    <template slot-scope="scope">
                        <div>{{ scope.row.name }}</div>
                        <div>{{ scope.row.code }}</div>
                    </template>
                </el-table-column>
                <!-- 商品价格（元） -->
                <el-table-column label="商品价格（元）" min-width="120">
                    <template slot-scope="scope">
                        <div>{{ scope.row.salePrice }}</div>
                    </template>
                </el-table-column>
                <!-- 审核状态 -->
                <el-table-column label="审核状态" prop="auditStatus" min-width="120">
                    <template slot-scope="scope">
                        <div v-if="scope.row.applyStatus === 1">待审核</div>
                        <div v-else-if="scope.row.applyStatus === 2">已通过</div>
                        <div v-else-if="scope.row.applyStatus === 3">已驳回</div>

                    </template>
                </el-table-column>
                <!-- 申请时间 -->
                <el-table-column label="申请时间" prop="appleTime" min-width="180"></el-table-column>
                <!-- 操作 -->
                <el-table-column label="操作" width="150" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleRule(scope.$index)" :disabled="!scope.row.adPlanId">分账规则</el-button>
                        <el-button type="text" @click="handleStrategy(scope.$index)" :disabled="!scope.row.adPlanId">销售策略</el-button>
                        <el-button type="text" @click="handleControl(scope.$index)" :disabled="!scope.row.salePlanId">销售控制</el-button>
                        <el-button type="text" @click="handleDetail(scope.$index)" :disabled="!scope.row.goodsSkuId">商品详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-box">
            <el-pagination layout="prev, pager, next , jumper, sizes, total" :total="page.total" :page-size="page.size"
                :current-page="page.current" background @current-change="handlePageChange" :page-sizes="[10, 20, 30, 40, 50]"
                @size-change="handlePageSizeChange"
            >
            </el-pagination>
        </div>
        <SalesRuleDialog ref="salesRuleDialogRef"/>
        <SalesMethodDialog ref="salesMethodDialogRef"/>
        <SalesControlDialog ref="salesControlDialogRef"/>
        <SalesGoodsDialog ref="salesGoodsDialogRef"/>
    </div>
</template>
<script>
import SalesRuleDialog from './components/salesRuleDialog.vue'
import SalesMethodDialog from './components/salesMethodDialog.vue'
import SalesControlDialog from './components/salesControlDialog.vue'
import SalesGoodsDialog from './components/salesGoodsDialog.vue'
import{
    plDkxGoodsPage
} from "@/api/saleRule/agent"
export default {
    name: 'plMutilControl',
    components: {
        SalesRuleDialog,
        SalesMethodDialog,
        SalesControlDialog,
        SalesGoodsDialog
    },
    data() {
        return {
            containerRef: null,
            searchBoxRef: null,
            tableBoxRef: null,
            tableBoxHeight: 200,
            searchForm: {
                name: '',
            },
            page: {
                current: 1,
                size: 10,
                total: 0
            },
            tableData: []
        }
    },
    created() {
        // 查询高度
        this.$nextTick(() => {
            const containerHeight = this.$refs.containerRef.offsetHeight;
            const searchBoxHeight = this.$refs.searchBoxRef.offsetHeight;
            this.tableBoxHeight = containerHeight - searchBoxHeight - 20 - 24 - 35;
        })
        this.getData();
    },
    methods: {
        // 跳转分账规则
        handleRule(index) {
            this.$refs.salesRuleDialogRef.publicOpen(this.tableData[index])
        },
        // 跳转销售策略
        handleStrategy(index) {
            this.$refs.salesMethodDialogRef.publicOpen(this.tableData[index])
        },
        // 跳转销售控制
        handleControl(index) {
            this.$refs.salesControlDialogRef.publicOpen(this.tableData[index])
        },
        // 跳转商品详情
        handleDetail(index) {
            const row = this.tableData[index];
            window.sessionStorage.setItem('agentProductItem', JSON.stringify(row));
            this.$refs.salesGoodsDialogRef.publicOpen(row)
        },
        // 页码变化
        handlePageChange(page) {
            this.page.current = page;
            this.getData();
        },
        // 页码大小变化
        handlePageSizeChange(size) {
            this.page.current = 1;
            this.page.size = size;
            this.getData();
        },
        // 获取数据
        async getData() {
            const params = {
                current: this.page.current,
                size: this.page.size,
                key: this.searchForm.name
            }
            const res = await plDkxGoodsPage(params);
            if (res) {
                const {records, total, current, size} = res
                if (records && records.length > 0) {
                    this.tableData = records;
                    this.page.total = total;
                    this.page.current = current;
                }else{
                    this.tableData = [];
                    this.page.total = 0;
                    this.page.current = 1;
                }
            }
        },
        // 搜索
        handleSearch() {
            this.page.current = 1;
            this.getData();
        },
        // 重置
        handleReset() {
            this.searchForm = {
                name: '',
            };
            this.page.current = 1;
            this.getData();
        }
    }
}
</script>
<style scoped lang="scss">
.container {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
    background-color: #ffffff;
    padding: 12px;
    overflow-y: auto;

    .search-box {
        margin-bottom: 20px;
        display: flex;
        align-items: center;
        .search-item {
            width: 450px; 
        }
        .search-btn {
            display: flex;
            justify-content: flex-end;
            margin-left: 20px;
        }
    }
    .search-form {
        font-size: 14px;
        
    }
    .table-box {
        display: flex;
        flex: 1;
        .el-table {
            width: 100%;
        }
    }
    .pagination-box {
        text-align: center;
    }
}
</style>